import React from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ModalCloneItem = props => {
  const {
    handleModalClose,
    handleModalConfirmYes,
    showModal,
    titleModal,
    bodyModal,
    nameItemWillClone
  } = props;

  return (
    <React.Fragment>
      <Modal show={showModal} onHide={handleModalClose} animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>{titleModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {bodyModal}{' '}
          <Badge variant="dark" className="">
            <h5 className="m-1">{nameItemWillClone}</h5>
          </Badge>{' '}
          ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            <i className="fa fa-arrow-left"></i>
            &nbsp;Voltar
          </Button>
          <Button variant="primary" onClick={handleModalConfirmYes}>
            <i className="fa fa-copy"></i>
            &nbsp;Clonar
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

ModalCloneItem.propTypes = {
  handleModalClose: PropTypes.func,
  handleModalConfirmYes: PropTypes.func,
  showModal: PropTypes.bool,
  titleModal: PropTypes.string,
  bodyModal: PropTypes.string,
  nameItemWillClone: PropTypes.string
};

export default ModalCloneItem;
